import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { MyXHRBackend } from './MyXHRBackend';
import { environment } from '../environments/environment';
import { version } from './version';

// Service
import { LoginService } from './login/service/login.service';
import { Subscription } from "rxjs/Rx";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	providers: [
		LoginService,
		HttpModule
	]
})

export class AppComponent implements OnInit {
	public token;

	private code: string;
	public permissoes: any[] = [];
	public userName: string = "";
	public userID: string = "";
	public companyPermission: string = "";
	public selectedCompany: string = "";
	public loginSubcription = new Subscription;
	public appVersion = "";

	constructor(private router: Router, private route: ActivatedRoute, private loginService: LoginService, private flashMessagesService: FlashMessagesService) {

		// Force https redirection
		if (environment.production) {
			if (location.protocol != 'https:') {
				location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
				return;
			}
		}

		this.token = localStorage.getItem('yara.token');
		
		this.router.events.filter(e => e.constructor.name === 'RoutesRecognized').pairwise().subscribe((e: any[]) => {
			console.log("route", e);
			if (e[0].urlAfterRedirects.indexOf("unauthorized") === -1) { // Nao memoriza caso seja erro
				if (e[0].urlAfterRedirects.indexOf("/login") === -1 && e[1].urlAfterRedirects.indexOf("/login") === -1) {
					localStorage.setItem('yara.previousPage', e[0].urlAfterRedirects); // Guarda a URL anterior
				}
			}
			if (!localStorage.getItem('yara.token')) {
				if (e[1].urlAfterRedirects !== '/login') {
					this.userLogout(false);
				}
			}
		});
	}

	ngOnInit() {
		this.appVersion = version;
	
		this.loginSubcription = this.loginService.permissionsLoaded.subscribe(value => {
			this.loadStoredData(true);
		});
	
		this.loadStoredData(false);
	
		if (window.location.href.indexOf("?display=page&code=") >= 0) {
			localStorage.removeItem('yara.token');
			localStorage.removeItem('yara.permissions');
			localStorage.removeItem('yara.userName');
			localStorage.removeItem('yara.companyPermission');
			localStorage.removeItem('yara.selectedCompany');
			localStorage.removeItem('yara.companys');
			localStorage.removeItem('yara.connectionHeader');
			localStorage.removeItem('yara.userID');
			localStorage.removeItem('yara.tokenID');
	
			var urlVars = this.getUrlVars(window.location.href);
			
			if (urlVars['code']) {
				console.log('SF Code',urlVars['code']);
	
				if (document.referrer) {
					console.log('referrer',document.referrer);
					sessionStorage.setItem('yara.Referrer',document.referrer);
				}
	
				if (urlVars['state']) {
					console.log('SF State',urlVars['state']);
					this.router.navigateByUrl('/login/sfcc/'+urlVars['state']+'/'+urlVars['code']);
				} else {
					this.router.navigateByUrl('/login/sf/'+urlVars['code']);
				}
				return;
			}
		}
	
		MyXHRBackend.emitter.subscribe((response) => {
			console.log("Hi, I received this response object: ", response);

			// if (response.errorCode == '401' && response.errorDescription == 'InvalidToken') {
			// 	this.logoutUser();
			// 	return;
			// }

			// if (response.errorCode == '401' && response.errorDescription == 'Unauthorized' && this.testTokenExpireDate()) {
			// 	this.logoutUser();
			// 	return;
			// }

			if (response.errorCode == '401') {
				if (response.errorDescription == 'InvalidToken' || this.testTokenExpireDate()) {
				// if (this.testTokenExpireDate()) {
					this.logoutUser();
					return;
				}
			}
	
			this.router.navigateByUrl('/unauthorized/' + response.errorCode);
		});
	}

	acessaParametros() {
		return (this.permissoes['ParametroSistema_Acesso'] ||
		this.permissoes['Usuario_Acesso'] ||
		this.permissoes['GrupoUsuario_Acesso'] ||
		this.permissoes['EstruturaPerfilUsuario_Acesso'] ||
		this.permissoes['TipoCliente_Acesso'] ||
		this.permissoes['Segmento_Acesso'] ||
		this.permissoes['Anexo_Acesso'] ||
		this.permissoes['Cultura_Acesso'] ||
		this.permissoes['CulturaEstado_Acesso'] ||
		this.permissoes['CustoHaRegiao_Acesso'] ||
		this.permissoes['AreaIrrigada_Acesso'] ||
		this.permissoes['Experiencia_Acesso'] ||
		this.permissoes['IdadeMediaCanavial_Acesso'] ||
		this.permissoes['PorcentagemQuebra_Acesso'] ||
		this.permissoes['TipoEndividamento_Acesso'] ||
		this.permissoes['TipoGarantia_Acesso'] ||
		this.permissoes['TipoPecuaria_Acesso'] ||
		this.permissoes['TipoEmpresa_Acesso'] ||
		this.permissoes['TipoReceita_Acesso'] ||
		this.permissoes['MotivoAbono_Acesso'] ||
		this.permissoes['MotivoProrrogacao_Acesso'] ||
		this.permissoes['OrigemRecurso_Acesso'] ||
		this.permissoes['OpcoesProdutoServico_Acesso'] ||
		this.permissoes['EstruturaComercialDiretoria_Acesso'] ||
		this.permissoes['StatusCobranca_Acesso'] ||
		this.permissoes['FluxoLiberacaoLimite_Acesso'] ||
		this.permissoes['FluxoLiberacaoLimiteCreditoAdicional_Acesso'] ||
		this.permissoes['FluxoLiberacaoAbono_Visualizar'] ||
		this.permissoes['FluxoLiberacaoProrrogacao_Visualizar'] ||
		this.permissoes['FluxoLimite_Acesso'] ||
		this.permissoes['FluxoGrupoEconomico_Acesso'] ||
		this.permissoes['FluxoRenovacaoLimite_Acesso'] ||
		this.permissoes['TipoRelacaoGrupoEconomico_Visualizar'] ||
		this.permissoes['ConceitoCobranca_Acesso'] ||
		this.permissoes['Feriado_Acesso'] ||
		this.permissoes['Log_Acesso']);
	}

	getUrlVars(location: string) {
		var vars = [], hash;
		var hashes = location.slice(location.indexOf('?') + 1,location.indexOf('#')).split('&');

		for(var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}

		return vars;
	}

	testTokenExpireDate() {
		var token_expires = new Date(Date.parse(localStorage.getItem('yara.token_expires')));
		return token_expires < new Date();
	}

	logoutUser() {
		console.log("Hi, I'm logging out this user.");

		localStorage.removeItem('yara.previousPage');
		localStorage.removeItem('yara.token');
		localStorage.removeItem('yara.permissions');
		localStorage.removeItem('yara.userName');
		localStorage.removeItem('yara.companyPermission');
		localStorage.removeItem('yara.selectedCompany');
		localStorage.removeItem('yara.companys');
		localStorage.removeItem('yara.connectionHeader');
		localStorage.removeItem('yara.userID');
		localStorage.removeItem('yara.tokenID');

		this.router.navigateByUrl('/login');
	}

	loadStoredData(isLogin) {
		if (localStorage.getItem('yara.permissions')) {
			console.log('loadStoredData - isLogin',isLogin);
			this.permissoes = JSON.parse(localStorage.getItem('yara.permissions'));
			this.userName = localStorage.getItem('yara.userName');
			this.userID = localStorage.getItem('yara.userID');
			this.companyPermission = localStorage.getItem('yara.companyPermission');
			this.selectedCompany = localStorage.getItem('yara.selectedCompany');

			($("header") as any).show();

			if (isLogin) {
				if (localStorage.getItem('yara.previousPage') && localStorage.getItem('yara.previousPage') != '/') {
					this.router.navigateByUrl(localStorage.getItem('yara.previousPage'));
				} else {
					this.router.navigateByUrl('/cockpit');
				}
			}
		} else {
			this.userLogout(true);
		}
	}

	changeCompany(companyID) {
		this.loginService.changeCompany(this.token, this.userID, this.userName, companyID).subscribe(result => {
			if (result.Success) {
				this.selectedCompany = companyID;
				localStorage.setItem('yara.selectedCompany', companyID);
				this.flashMessagesService.show("Empresa alterada com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				window.location.reload();
			} else {
				this.flashMessagesService.show("Ocorreu um erro ao tentar alterar a empresa", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	userLogout(userAction) {
		console.log("Hi, I'm logging out this user.");

		if (userAction) {
			localStorage.removeItem('yara.previousPage');
		}

		localStorage.removeItem('yara.token');
		localStorage.removeItem('yara.permissions');
		localStorage.removeItem('yara.userName');
		localStorage.removeItem('yara.companyPermission');
		localStorage.removeItem('yara.selectedCompany');
		localStorage.removeItem('yara.companys');
		localStorage.removeItem('yara.connectionHeader');
		localStorage.removeItem('yara.userID');
		localStorage.removeItem('yara.tokenID');

		this.router.navigateByUrl('/login');
	}

	ngOnDestroy() {
		this.loginSubcription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts